<template>
    <div class="attachment-reader-box">
        <!--  -->
        <span @click="open()"><i class="far fa-file"></i> {{ name }}{{ extension }}</span
        >
        <span @click="remove" class="attachment-close-box" v-show="deletable"><i class="fas fa-times"></i></span>
    </div>
</template>

<script>
export default {
    name: 'AttachmentReader',
    props: {
        name: {
            type: String,
            default: 'Padrão',
        },
        path: {
            type: String,
            default: '#',
        },
        extension: {
            type: String,
            default: '',
        },
        index: {
            type: Number,
            default: 0,
        },
        deletable: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        open() {
            window.open(this.path);
        },
        remove() {
            this.$emit('delete', this.index);
        },
    },
};
</script>

<style>
.attachment-reader-box {
    background-color: #efefef;
    color: #007bff;
    padding-top: 1px;
    padding-bottom: 1px;
    padding-inline: 15px;
    border: 1px solid #efefef;
    border-radius: 37px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center
}
.attachment-close-box {
    color: #707070;
    font-size: 11px;
    margin-left: 5px;
}
</style>
